<template>
    <div class="filter-container">
        <el-checkbox-group v-model="listQuery.status" @change="changeStatus">
            <el-checkbox-button v-for="[key, label] in statusMap" :key="key" :label="key">{{ label
                }}</el-checkbox-button>
        </el-checkbox-group>
        <br />
        <el-select clearable class="filter-item width_150" v-model="listQuery.clueType" placeholder="线索类型"
            @change="listQuery.source = []">
            <el-option v-for="[key, label] in clueTypeMap" :key="key" :label="label" :value="key"></el-option>
        </el-select>
        <el-select class="filter-item width_150" v-model="listQuery.source" multiple placeholder="选择渠道">
            <el-option v-for="item in sourceList" :key="item.dataName" :label="item.dataDisplay"
                :value="item.dataName"></el-option>
        </el-select>

        <el-input clearable class="filter-item width_200" placeholder="线索ID" v-model.number="listQuery.clueId"></el-input>

        <el-cascader clearable class="filter-item width_350" placeholder="选择经销商" filterable
            :props="{ checkStrictly: true }" :show-all-levels="false" :options="dealerOptions"
            v-model="listQuery.dealerCode"></el-cascader>
        <el-input clearable class="filter-item width_200" placeholder="省份" v-model="listQuery.province"></el-input>
        <el-input clearable class="filter-item width_200" placeholder="城市" v-model="listQuery.city"></el-input>
        <el-input clearable class="filter-item width_200" placeholder="姓名或手机号" v-model="listQuery.name"></el-input>
        <el-select placeholder="线索流量类型" class="filter-item width_200" v-model="listQuery.flowType" @clear="listQuery.flowType = null" clearable>
            <el-option v-for="[key, value] in flowTypeMap" :key="key" :label="value" :value="key"></el-option>
        </el-select>
        <el-input clearable class="filter-item width_200" placeholder="客户经理" v-model.number="listQuery.ownerName"></el-input>
        <el-input clearable class="filter-item width_200" placeholder="系统车系" v-model="listQuery.specName"></el-input>
        <el-select multiple class="filter-item width_200" v-model="listQuery.salesLevel" placeholder="经销商等级">
            <el-option v-for="item in salesLevels" :key="item.dataName" :label="item.dataName"
                :value="item.dataName"></el-option>
        </el-select>
        <el-select class="filter-item width_150" v-model="listQuery.dateType" v-if="
            showTimeStatusList.includes(listQuery.status[0])">
            <el-option label="创建时间" :value="1"></el-option>
            <el-option label="操作时间" :value="2"></el-option>
        </el-select>
        <el-date-picker v-model="listQuery.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        <el-input clearable class="filter-item width_200" placeholder="线索来源" v-model="listQuery.sourceDesc"></el-input>
        <el-select placeholder="是否异地购车" class="filter-item width_200" v-model="listQuery.isRemote">
            <el-option v-for="[key, value] in remoteMap.entries()" :key="key" :label="value" :value="key"></el-option>
        </el-select>
        
        <el-button class="filter-item" type="info" icon="el-icon-search" @click="doSearch">
            搜索
        </el-button>
        <el-button class="filter-item" icon="el-icon-refresh" @click="doReset">
            重置
        </el-button>
        <el-button class="filter-item" v-if="isSuper ? 'true' : roles_all.includes('ONLINE_CLUE_CAN_ADD')"
            icon="el-icon-plus" @click="showAddDialog">
            添加
        </el-button>
        <el-button class="filter-item" v-if="isSuper ? 'true' : roles_all.includes('ONLINE_CLUE_CAN_RESEND')"
            @click="resendOrders">
            重发
        </el-button>
        <el-button class="filter-item" v-if="isSuper ? 'true' : roles_all.includes('ONLINE_CLUE_CAN_RECOVER')"
            @click="showAssignDealerDialog">
            回收
        </el-button>
        <el-button class="filter-item" v-if="isSuper ? 'true' : roles_all.includes('ONLINE_CLUE_CAN_IMPORT')"
            icon="el-icon-upload2" @click="showImportDialog">
            导入
        </el-button>
        <el-button class="filter-item" v-if="isSuper ? 'true' : roles_all.includes('ONLINE_CLUE_CAN_EXPORT')"
            icon="el-icon-download" @click="doExport">
            导出
        </el-button>
    </div>
</template>

<script>
import store from "@/store";
import { CONSTANT_0, CONSTANT_1, CONSTANT_2, statusMap, clueTypeMap, flowTypeMap, salesLevels, remoteMap, showTimeStatusList, singleStatusList } from '../js/form-options'
export default {
    props: {
        listQuery: {
            type: Object,
            required: true,
            default: () => { }
        },
        importSources: {
            type: Array,
            required: true,
            default: () => []
        },
        offlineSources: {
            type: Array,
            required: true,
            default: () => []
        },
        dealerOptions: {
            type: Array,
            required: true,
            default: () => []
        },
    },
    data() {
        return {
            statusMap: Object.freeze(statusMap),
            clueTypeMap: Object.freeze(clueTypeMap),
            salesLevels: Object.freeze(salesLevels),
            remoteMap: Object.freeze(remoteMap),
            flowTypeMap: Object.freeze(flowTypeMap),
            CONSTANT_0: Object.freeze(CONSTANT_0),
            CONSTANT_1: Object.freeze(CONSTANT_1),
            CONSTANT_2: Object.freeze(CONSTANT_2),
            showTimeStatusList: Object.freeze(showTimeStatusList),
            singleStatusList: Object.freeze(singleStatusList),
            seriesOptions: [], // 意向车系
            viewType: 0,
            isSuper: store.getters.user.isSuper,
            roles: store.getters.roles,
            roles_all: [],
        }
    },
    computed: {
        sourceList() {
            if (this.listQuery.clueType === CONSTANT_1) {
                return this.importSources
            } else if (this.listQuery.clueType === CONSTANT_2) {
                return this.offlineSources
            }
            return this.importSources.concat(this.offlineSources)
        }
    },
    watch: {
    },
    mounted() {
        const v = this
        this.roles.forEach((item) => {
            this.roles_all.push(item.identify);
        });
        this.viewType = JSON.parse(localStorage.getItem("Admin-User")).viewType;
        this.retrieveSeriesOptions();
    },
    methods: {
        changeStatus(newVal) {
            if (newVal.length > 0) {
                if (this.singleStatusList.includes(newVal[0])) {
                    newVal.splice(0, 1);
                    this.listQuery.status = newVal;
                    this.doSearch();
                    return;
                }
                if (this.singleStatusList.includes(newVal[newVal.length - 1])) {
                    this.listQuery.status = [newVal[newVal.length - 1]];
                    this.doSearch();
                    return;
                }
            }
            if (newVal.length === 0) {
                this.listQuery.status = [99];
            }
            this.doSearch();
        },
        // 意向车系，基于现有可售车系数据
        retrieveSeriesOptions() {
            this.$httpAuth
                .post("/v1/backendVehicleRpc/validSeriesList", {})
                .then(res => {
                    this.seriesOptions = res.data?.records || [];
                });
        },
        doExport() {
            this.$emit("do-export")
        },
        doSearch() {
            this.$emit("do-search")
        },
        doReset() {
            this.$emit("do-reset")
        },
        showAddDialog() {
            this.$emit("show-add-dialog")
        },
        resendOrders() {
            this.$emit("resend-orders")
        },
        showAssignDealerDialog() {
            this.$emit("show-assign-dealer-dialog")
        },
        showImportDialog() {
            this.$emit("show-import-dialog")
        }
    }
}
</script>
<style lang="scss" scoped>
.width_150 {
    width: 150px;
}

.width_180 {
    width: 180px;
}

.width_200 {
    width: 200px;
}

.width_350 {
    width: 350px;
}
</style>